import gql from "@/util/graphql-query.mjs";

export const userFragmentStr = `
  birthday
  email
  gender
  id
  insertedAt
  isTrial
  location
  name
  updatedAt
  emailUpdatedAt
  roles {
    id
    code
  }
  defaultSummoner {
    id
    isPro
    region
    summonerId
  }
  preferences {
    accountUserId
    config
    id
  }
  summoners {
    id
    isPro
    region
    summonerId
  }
  defaultFortniteUser {
    fortniteAccountId
    id
  }
  fortniteUsers {
    fortniteAccountId
    id
  }
  defaultValorantUser {
    id
    riotAccountId
  }
  riotSideGamesUsers {
    id
    riotAccountId
  }
`;

export const GetMe = gql`query GetMe {
  me {
    ${userFragmentStr}
  }
}`;

export const UpdateUser = gql`
  mutation UpdateUser($user: UpdateUserInput!) {
    updateUser(user: $user) {
      ${userFragmentStr}
    }
  }
`;

export const ChangeEmail = gql`
  subscription ChangeEmail($language: String, $newEmail: String!) {
    changeEmail(languageCode: $language, newEmail: $newEmail) {
      email
    }
  }
`;

export const isEmailTaken = gql`
  query isEmailTaken($email: String!) {
    isEmailTaken(email: $email)
  }
`;

export const DeleteBlitzUser = gql`
  mutation deleteUser {
    deleteUser
  }
`;

export const GetRoles = `query roles {
  me {
    roles {
      id
      code
    }
  }
}`;

export const GetActiveSessions = `query activeSessions {
  activeSessions {
    browserClient,
    ip,
    isCurrentSession,
    operatingSystem,
    sessionCreatedAt,
  	sessionExpiry,
  	sessionTrackerId
  }
}`;

export const RemoveActiveSession = `
mutation removeSession($sessionTrackerIds: [String!]) {
  removeSession(sessionTrackerIds: $sessionTrackerIds)
}
`;
